export function isGovCloudRegion(region?: string): boolean {
  if (!region) return false;
  return region.startsWith('us-gov-');
}

export function getCognitoRegion(): string {
  return (
    (window as Window & { __env__?: { cognito?: { cognito_region?: string } } })
      .__env__?.cognito?.cognito_region ||
    process.env.REACT_APP_COGNITO_REGION ||
    ''
  );
}
